"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideToast = exports.HIDE_TOAST = exports.renderToast = exports.RENDER_TOAST = exports.showToast = exports.SHOW_TOAST = void 0;

var typesafe_actions_1 = require("typesafe-actions"); // Show Toast


exports.SHOW_TOAST = 'Show toast';

var showToast = function showToast(toast) {
  return typesafe_actions_1.action(exports.SHOW_TOAST, {
    toast: toast
  });
};

exports.showToast = showToast; // Render Toast

exports.RENDER_TOAST = 'Render toast';

var renderToast = function renderToast(id) {
  return typesafe_actions_1.action(exports.RENDER_TOAST, {
    id: id
  });
};

exports.renderToast = renderToast; // Hide Toast

exports.HIDE_TOAST = 'Hide toast';

var hideToast = function hideToast(id) {
  return typesafe_actions_1.action(exports.HIDE_TOAST, {
    id: id
  });
};

exports.hideToast = hideToast;